import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Handle = _resolveComponent("Handle")!

  return (_openBlock(), _createElementBlock("div", {
    ref: _ctx.uid.toString(),
    id: _ctx.id.toString(),
    style: _normalizeStyle('flex:' + _ctx.componentState.flex + `; flex-direction:` + _ctx.type),
    class: _normalizeClass(["layout-container", { 'row-p': _ctx.type == 'row', 'column-p': _ctx.type == 'column' }])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.children, (child, i) => {
      return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.getComponentType(child)), {
        ref_for: true,
        ref: 'component_' + child.id,
        key: i,
        type: child.type,
        componentState: child.componentState,
        componentName: child.componentName,
        children: child.children || [],
        id: child.id,
        component: child.component
      }, null, 8, ["type", "componentState", "componentName", "children", "id", "component"]))
    }), 128)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.handleIds, (child, i) => {
      return (_openBlock(), _createBlock(_component_Handle, {
        ref_for: true,
        ref: 'handle_' + child,
        handleIds: [_ctx.allIds[i], _ctx.handleIds[i]],
        key: i + 'h',
        type: _ctx.type
      }, null, 8, ["handleIds", "type"]))
    }), 128))
  ], 14, _hoisted_1))
}